import { render, staticRenderFns } from "./lab-order-form.vue?vue&type=template&id=b634a252&"
import script from "./lab-order-form.vue?vue&type=script&lang=js&"
export * from "./lab-order-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports